<template lang="html">

  <div v-if="handleShow" class="boxMask">
    <div class="warnList" style="position:absolute">
      <img src="../../../assets/views/map/warning1.png" class="warning-img" />
      <p class="warning-message">地图对齐后</p>
      <p class="warning-message">才可以进行触点生成</p>
    </div>
  </div> 
  <div v-else class="mng-editor-content" >
    
    <div v-if='QrcodeFlag' class="qr-code">
      <QrCode ref="qrcode" @closeQr = "closeQrPanel"/>
    </div>
    <div class="mng-editor-panel">
      <div class="mng-editor-panel__block">
        <div>
          触点列表
        </div>
        <!-- <div class ="editor-panel-labelbutton">
          <span>前端显示</span>
          <el-switch v-model="viewEditable" />
        </div> -->
      </div>
      <div class="mng-editor-panel__block mng-editor-panel__block--last">
        <div class="editor-panel-list">
          <div class="editor-panel-list__title">
            <span>触点名称</span>
            <span>操作</span>
          </div>
          <div ref="listcontainer" class="editor-panel-list__items">
            <div v-for="(item, index) in roamlist" :key="index" 
              class="editor-panel-list__item"
              :class="{'editor-panel-list--active':item.selected}"
              @click="click(item)">
              <span>{{ item.touch_point_name }}</span>
              <!-- <span>{{ item.panoramaId }}</span> -->
              <div class="editor-panel-list__actions">
                <!-- <div class="ai-button ai-button--text ai-button--text--primary"
                     @click.stop="upItem(item)"> -->
                <div class="ai-button ai-button--text ai-button--text--primary"
                     @click.stop="showReNameConfirm(item)">
                
                  <span>重命名</span>
                </div>
                <!-- <div class="ai-button ai-button--text ai-button--text--primary"
                     @click.stop="downItem(item)"> -->
                <div v-show="item.selected" class="ai-button ai-button--text ai-button--text--primary"
                     @click.stop="reSavePoint(item)">
                   <span>更新</span>
                </div>
                <div class="ai-button ai-button--text ai-button--text--danger"
                     @click.stop="showDeleteConfirm(item)">
                  删除
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class='funcBtn'>
        <div class="add-new-point" @click="addRoamPoint">
          <img :src="addIcon"/> &nbsp添加新触点</div>
        <div class="create-qr" @click="createQrcode">
          <img :src="qrIcon"/> &nbsp生成二维码</div>
        </div>
    </div>
    <div class="mng-vr-scene" v-show="!this.handleShow">
      <VrScene ref="vrScene"
               class="mng-vr-scene__stage"
               :scene-id="$store.state.storeId"
               @pano-icon-right-click="onPointClicked"
               @initialized="onInitialized"
               @roam-move="onRoamMove" />
      <transition name="fade" mode="out-in" appear>
        <div class="frame-support">
          <div :style="frameStyle" class="frame-support__frame">
            <div class="frame-support__corner frame-support__corner--topleft" />
            <div class="frame-support__corner frame-support__corner--topright" />
            <div class="frame-support__corner frame-support__corner--bottomleft" />
            <div class="frame-support__corner frame-support__corner--bottomright" />
          </div>
        </div>
      </transition>
    </div>
   
      
  </div>
</template>

<script>
/* eslint-disable */
import VrScene from "@/components/ai-vr-scene.vue";
import QrCode from "./qrCode";

export default {
  components: {
    VrScene,
    QrCode
  },
  data() {
    return {
      handleShow: !0,
      nowselect: null,
      items: [],
      roamlist: [],
      pointEditable: false,
      viewEditable: false,
      frameStyle: {
        height: 0,
        width: 0
      },
      canedit: false,
      QrcodeFlag: !!0,
      addIcon: require(`@/assets/views/map/icon/add.png`),
      qrIcon: require(`@/assets/views/map/icon/qr.png`),
      beforeName: ""
    };
  },
  mounted() {
    // this.loadPanoramaIcons();
    // if (this.$store.state.mergeFlag === "false") {
    //   // console.log('ok')
    //   this.handleShow = true;
    //   return;
    // }
    this.isAlign();
    window.addEventListener("resize", this.updateFrame);
    // console.log(this.$store.state.alignFlag);

    this.updateFrame();

    if (this.handleShow) return;
    // console.log(this.$store.state.alignFlag,!0,!1);
    // console.log(!!this.$store.state.alignFlag);
  },
  beforeDestroy() {
    // do something before destroying vue instance
    window.removeEventListener("resize", this.updateFrame);
  },
  methods: {
    async isAlign() {
      const { data } = await this.$http.post(
        "/navigation/init-navigation-map",
        {
          map_id: this.$route.params.mapId
        }
      );
      // console.log(data);
      if (data.error_no === 200) {
        this.$store.commit("getAlign", data.data.is_aligned);

        this.handleShow = data.data.is_aligned === 0 ? !0 : !!0;
      }
    },
    closeQrPanel() {
      this.QrcodeFlag = !!0;
    },
    onInitialized() {
      this.getData();
    },
    async getData() {
      try {
        const {
          data: { data }
        } = await this.$http.post("/animation/fetch", {
          store_id: this.$store.state.storeId
        });
        this.roamlist = data;
        for (let i = 0; i < this.roamlist.length; i++) {
          this.roamlist[i].selected = false;
        }
        //  console.log('-----------------',data);
      } catch (error) {
        this.$log(error);
      }

      try {
        const { data } = await this.$http.post("/navigation/touch-point", {
          store_id: this.$route.query.store_id
        });

        if (data.error_no === 200) {
          console.log(data.data);

          // this.roamlist = data.data.touch_points;
          data.data.touch_points.forEach(v => {
            const point = {};

            const position = {};
            const pos = { position: position };
            point.touch_point_id = v.touch_point_id;
            point.touch_point_name = v.touch_point_name;
            point.panoramaId = v.panorama_id;
            position.x = v.roaming_direction_x;
            position.y = v.roaming_direction_y;
            position.z = v.roaming_direction_z;
            point.selected = !!0;
            Object.assign(point, pos);
            this.roamlist.push(point);
          });
          // console.log(this.roamlist);
        } else {
          this.$log(data.error_msg);
        }
      } catch (error) {
        this.$log(error.error_msg || error);
      }
    },
    updateFrame() {
      setTimeout(() => {
        const scene = this.$refs.vrScene.$el;
        this.frameStyle = {
          height: `${scene.clientHeight - 16}px`,
          width: `${(scene.clientHeight - 16) * 0.5625}px`
        };
      }, 200);
    },
    click(item) {
      if (this.nowselect) {
        this.nowselect.selected = false;
        this.nowselect = item;
      } else {
        this.nowselect = item;
      }
      this.nowselect.selected = true;
      //  item.position.x = item.roaming_direction_x;
      // console.log(item);

      this.canedit = true;
      this.$refs.vrScene.moveToRoam(item);
    },
    // reName(item) {},
    upItem(item) {
      if (item.id === 0) return;
      for (let i = 0; i < this.roamlist.length; i++) {
        if (this.roamlist[i].id === item.id) {
          const tempid = item.id;
          this.roamlist[i].id = this.roamlist[i - 1].id;
          this.roamlist[i - 1].id = tempid;
        }
      }
      this.roamlist.sort(function(a, b) {
        return a.id - b.id;
      });
    },
    downItem(item) {
      if (item.id === this.roamlist.length - 1) return;
      for (let i = 0; i < this.roamlist.length; i++) {
        if (this.roamlist[i].id === item.id) {
          const tempid = item.id;
          this.roamlist[i].id = this.roamlist[i + 1].id;
          this.roamlist[i + 1].id = tempid;
        }
      }
      this.roamlist.sort(function(a, b) {
        return a.id - b.id;
      });
    },
    showDeleteConfirm(id) {
      this.$confirm({
        title: "警告",
        message: "确认要删除该触点吗?"
      })
        .then(() => {
          this.deleteLabel(id);
        })
        .catch(() => {});
    },
    showReNameConfirm(item) {
      // console.log(item);
      this.beforeName = item.touch_point_name;
      this.$prompt("触点重命名", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(({ value }) => {
        // this.$message({
        //   type: "success",
        //   message: "你的邮箱是: " + value
        // });
        this.reName(item, value);
      });
      // .catch(() => {
      //   this.$message({
      //     type: "info",
      //     message: "取消输入"
      //   });
      // });
    },

    async addRoamPoint() {
      const {
        direction: { x, y, z },
        panoramaId
      } = this.$refs.vrScene.getCurrentView();
      const point = {
        touch_point_name: `触点${this.roamlist.length}`,
        panoramaId: panoramaId,
        selected: true,
        position: { x, y, z }
      };
      this.roamlist.push(point);
      // console.log(this.$route.query.store_id,point);

      try {
        const { data } = await this.$http.post(
          "/navigation/create-touch-point",
          {
            store_id: this.$route.query.store_id,
            panorama_id: point.panoramaId,
            roaming_direction_x: point.position.x,
            roaming_direction_y: point.position.y,
            roaming_direction_z: point.position.z,
            touch_point_name: point.touch_point_name
          }
        );

        if (data.error_no === 200) {
          // console.log(data.data);
          point.touch_point_id = data.data.touch_point_id;
        } else {
          this.$log(data.error_msg);
        }
      } catch (error) {
        this.$log(error.error_msg || error);
      }

      if (this.nowselect) this.nowselect.selected = false;
      this.nowselect = point;
      this.canedit = true;
      if (this.roamlist.length >= 18) {
        setTimeout(() => {
          this.$refs.listcontainer.scrollTop = this.$refs.listcontainer.scrollHeight;
        }, 10);
      }
    },
    async updateTouchPoint() {
      try {
        const { data } = await this.$http.post(
          "/navigation/update-touch-point",
          {
            touch_point_id: this.nowselect.touch_point_id,
            update_info: {
              touch_point_name: this.nowselect.touch_point_name,
              roaming_direction_x: this.nowselect.position.x,
              roaming_direction_y: this.nowselect.position.y,
              roaming_direction_z: this.nowselect.position.z
            }
          }
        );

        if (data.error_no === 200) {
          // console.log(data);
          this.$message("触点更新成功");
        } else {
          this.$log(data.error_msg);
        }
      } catch (error) {
        this.$log(error.error_msg || error);
      }
    },
    reSavePoint(item) {
      // console.log(item);
      // this.nowselect = item;
      const {
        direction: { x, y, z },
        panoramaId
      } = this.$refs.vrScene.getCurrentView();

      // console.log(this.nowselect);

      this.nowselect.position.x = x;
      this.nowselect.position.y = y;
      this.nowselect.position.z = z;

      this.updateTouchPoint();
    },
    playRoam() {
      // console.log(this.roamlist);
      this.$refs.vrScene.startRoamList(this.roamlist);
    },
    async saveRoam() {
      try {
        const data = await this.$http.post("/animation/save", {
          store_id: this.$store.state.storeId,
          data: this.roamlist
        });
        this.$message.basic({
          message: "保存list成功"
        });
      } catch (error) {
        this.$log(error);
      }
    },
    onRoamMove(roampoint) {
      for (let i = 0; i < this.roamlist.length; i++) {
        if (this.roamlist[i].id === roampoint.Id) {
          this.roamlist[i].selected = true;
          this.nowselect = this.roamlist[i];
        } else {
          this.roamlist[i].selected = false;
        }
      }
    },
    async reName(item, value) {
      // console.log(item, value);
      item.touch_point_name = value === null ? this.beforeName : value;

      // console.log(this.roamlist);
      try {
        const { data } = await this.$http.post(
          "/navigation/update-touch-point",
          {
            touch_point_id: item.touch_point_id,
            update_info: {
              touch_point_name: item.touch_point_name
            }
          }
        );

        if (data.error_no === 200) {
          // console.log(data);
        } else {
          this.$log(data.error_msg);
        }
      } catch (error) {
        this.$log(error.error_msg || error);
      }
    },
    async deleteLabel(item) {
      this.roamlist = this.roamlist.filter(
        i => i.touch_point_id != item.touch_point_id
      );
      // let i = 0;
      // for (let i = 0; i < this.roamlist.length; i++) {
      //   this.roamlist[i].id = i;
      // }

      try {
        const { data } = await this.$http.post(
          "/navigation/delete-touch-point",
          {
            touch_point_id: item.touch_point_id
          }
        );

        if (data.error_no === 200) {
          // console.log(data);
        } else {
          this.$log(data.error_msg);
        }
      } catch (error) {
        this.$log(error.error_msg || error);
      }

      this.canedit = false;
    },
    onPointEditableChange(editable) {
      if (editable) this.$refs.vrScene.setShowMode("edit");
      else this.$refs.vrScene.setShowMode("normal");
    },
    async loadPanoramaIcons() {
      const {
        data: {
          data: { panorama_icons: panoramaIcons }
        }
      } = await this.$http.post("/v1/list-brand-panorama-icons", {
        store_id: this.$store.state.storeId
      });
      this.$refs.vrScene.setPanoramaIcons(panoramaIcons);
    },
    async onPointClicked({ panoramaId, visible }) {
      if (!this.pointEditable) return;
      try {
        await this.$http.post(
          "/admin/modify-panorama?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so",
          {
            // store_id: 1,
            store_id: this.$store.state.storeId,
            panorama_id: panoramaId,
            visible: !visible
          }
        );
        this.$refs.vrScene.setPanoramaVisibility(panoramaId, !visible);
      } catch (error) {
        this.$log(error.error_msg || error);
      }
    },
    async updateInitialView() {
      const {
        direction: { x, y, z },
        panoramaId
      } = this.$refs.vrScene.getCurrentView();
      try {
        await this.$http.post(
          "/admin/modify-store-initial-view?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so",
          {
            store_id: this.$store.state.storeId,
            panorama_id: panoramaId,
            direction_x: x,
            direction_y: y,
            direction_z: z
          }
        );
        this.$message("修改成功");
      } catch (error) {
        this.$log(error.error_msg || error);
      }
    },
    createQrcode() {
      this.QrcodeFlag = !this.QrcodeFlag;
      this.$nextTick(() => {
        // console.log(this.$refs.qrcode.roamlist);

        this.QrcodeFlag
          ? ([...this.$refs.qrcode.startPoints] = this.roamlist)
          : null;
        // console.log(this.$refs.qrcode.roamlist);
      });
    },
    pickPointName() {
      const arr = [];
      this.roamlist.forEach(v => {
        arr.push(v.touch_point_name);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.switch-item {
  display: flex;
  align-items: center;

  span {
    margin-left: 7px;
    font-size: 12px;
    color: #666;
  }
}

.frame-support {
  top: 110px;
  left: 85px;
  width: calc(100% - 170px);
  height: calc(100% - 210px);
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  pointer-events: none;

  &__frame {
    border: 2px dashed #fff;
    position: relative;
  }

  &__corner {
    width: 50px;
    height: 50px;
    position: absolute;

    &--topleft {
      top: -4px;
      left: -4px;
      border-top: 6px solid #fff;
      border-left: 6px solid #fff;
    }

    &--topright {
      top: -4px;
      right: -4px;
      border-top: 6px solid #fff;
      border-right: 6px solid #fff;
    }

    &--bottomleft {
      bottom: -4px;
      left: -4px;
      border-bottom: 6px solid #fff;
      border-left: 6px solid #fff;
    }

    &--bottomright {
      bottom: -4px;
      right: -4px;
      border-bottom: 6px solid #fff;
      border-right: 6px solid #fff;
    }
  }
}

// .editor-panel-labelbutton {
//   margin-left: 220px;
//   font-size: 12px;
// }

.bottom_actions {
  width: calc(100% - 170px);
  display: grid;
  grid-template-columns: 15% 15% 40% 15% 15%;
  align-items: center;
  justify-content: center;
}

.editor-panel-list {
  height: 500px;
  border-radius: 4px;
  border: 1px solid #d8d8d8;
  display: flex;
  flex-direction: column;

  &__title {
    display: grid;
    background-color: #e5e5e5;
    grid-template-columns: 40% 60%;
    justify-items: center;
    align-items: center;
    height: 26px;
    font-size: 12px;
    color: #666;
    user-select: none;
  }

  &__items {
    overflow-y: scroll;
    flex: 1;
  }

  &--active {
    background-color: rgb(85, 107, 233);

    span {
      color: rgb(255, 255, 255);
    }
  }

  &__item {
    display: grid;
    grid-template-columns: 40% 60%;
    justify-items: center;
    align-items: center;
    height: 26px;
    font-size: 12px;

    &:last-child {
      border-bottom: 0;
    }
  }

  &__actions .ai-button {
    margin: 0 0px;
  }
}
.qr-code {
  position: absolute;
  width: 1000px;
  height: 540px;
  left: 50%;
  top: 50%;
  z-index: 100;
  background-color: #393939;
  transform: translate(-50%, -50%);
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
  border-radius: 30px;
}
.funcBtn {
  height: 32px;
  display: flex;
  justify-content: space-between;
  margin-top: -10px;
  .add-new-point,
  .create-qr {
    width: 120px;
    height: 30px;
    border: 1px solid #08ce82;
    border-radius: 4px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #08ce82;
    letter-spacing: 0.56px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .boxMask {
    width: 300px;
    height: 100%;
    z-index: 1000;
  }

  .warnList {
    width: 300px;
    height: 100%;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }

  .warning-img {
    width: 28px;
    height: 28px;
    margin-bottom: 22px;
  }

  .warning-message {
    font-size: 20px;
    color: #adadad;
    text-align: center;
    margin: 0;
  }
}
</style>
